import { render, staticRenderFns } from "./InsufficientCard.vue?vue&type=template&id=7481ebd2&"
import script from "./InsufficientCard.vue?vue&type=script&lang=js&"
export * from "./InsufficientCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports